import { createGlobalStyle } from 'styled-components';

/**
 * App-level global styles only. Typography, colours and scrollbars come from YCL's
 * `YabbleComponentLibraryBaseStyle`, rendered alongside this in `main.tsx`.
 */
export const BaseStyle = createGlobalStyle`
html, body, #root {
  height: 100%;
}

body {
  &, .p-component {
    font-family: 'SuisseIntl', sans-serif;
  }
}
`;
